import { render, staticRenderFns } from "./DetailCandidate.vue?vue&type=template&id=ed8c1db4&scoped=true"
import script from "./DetailCandidate.vue?vue&type=script&lang=js"
export * from "./DetailCandidate.vue?vue&type=script&lang=js"
import style0 from "./DetailCandidate.vue?vue&type=style&index=0&id=ed8c1db4&prod&lang=css"
import style1 from "./DetailCandidate.vue?vue&type=style&index=1&id=ed8c1db4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8c1db4",
  null
  
)

export default component.exports